<template>
  <div>
    <h2>Welcome to NBM Solicitors admin system</h2>
    <p>Navigate using the links on the left to find information stored in the NBM database.</p>
    <hr />
    <h3>Client website</h3>
    <p>To view NBM Solicitors client website please follow the link below.</p>
    <p>
      <v-btn @click="clientWebsite">Client website</v-btn>
    </p>
    <hr />
    <h3>Money laundering</h3>
    <p>NBM Solicitors have a money laundering compliance manual. Please access from the link below.</p>
    <p>
      <v-btn @click="businessReport(3)">Money Laundering Compliance manual</v-btn>
    </p>
    <hr />
    <h3>Equality and Diversity Policy</h3>
    <p>NBM Solicitors have an Equality and Diversity policy. Please access from the link below.</p>
    <p>
      <v-btn @click="businessReport(2)">Equality and Diversity Policy</v-btn>
    </p>
    <hr />
    <h3>Health and Safety Policy Statement</h3>
    <p>NBM Solicitors have a Health and Safety Policy Statement. Please access from the link below.</p>
    <p>
      <v-btn @click="businessReport(1)">Health and Safety Policy Statement</v-btn>
    </p>
    <hr />
    <h3>Council list</h3>
    <p>To view a list of all the councils click the link below (may take a minute to load)</p>
    <p>
      <v-btn @click="councilsReport">Council report</v-btn>
    </p>
    <hr />
    <h3>Business Continuity Plan</h3>
    <p>NBM have a Business Continuity Plan. Click the link below.</p>
    <p>
      <v-btn @click="businessReport(0)">Business Continuity Plan</v-btn>
    </p>
    <hr />
    <h3>Email system</h3>
    <p>Email system structure and security information</p>
    <p>
      <v-btn @click="businessReport(4)">Email system</v-btn>
    </p>
  </div>
</template>

<script>
export default {
  name: "Home",
  metaInfo() {
    return {
      title: "Home",
      titleTemplate: "%s - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  methods: {
    businessReport(value) {
      const url = `${process.env.VUE_APP_CT_URL}/cors/admin/document/businessReports/${value}`;
      window.open(url, "_blank");
    },
    clientWebsite() {
      window.open("https://www.nbmlaw.co.uk", "_blank");
    },
    councilsReport() {
      const url = `${process.env.VUE_APP_CT_URL}/cors/admin/directory/councilsReport`;
      window.open(url, "_blank");
    }
  }
};
</script>
